import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  FLOW_ALERT_BASE_PATH = '/flows-alerts';

  constructor(private http: HttpService) { }

  getFlowsAlerts(params: object = {}): Observable<any> {
    return this.http.get(`${this.FLOW_ALERT_BASE_PATH}`, params);
  }

  getFlowsAlertById(id: number): Observable<any> {
    return this.http.get(`${this.FLOW_ALERT_BASE_PATH}/${id}`);
  }

  updateFlowsAlertById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.FLOW_ALERT_BASE_PATH}/${id}`, body);
  }
}
